import React from 'react';
import Select from 'react-select';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { Form, FormGroup, Label, Input, Row, Col, Button, Spinner} from 'reactstrap';
import { toPostRequest, getWeeksDiff } from './functions/ExpandTableFunctions';
import { BsFileEarmarkArrowUp, BsFileEarmarkArrowDown, BsFileEarmarkCheck, BsFileEarmarkX } from 'react-icons/bs';
import { HiDocumentDownload } from 'react-icons/hi';
import './css/Formulario.css';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import url from './variables/url.js';
const local = url.localBack;
const localFront = url.localFront;
const MySwal = withReactContent(Swal)

const GRADO_NIVEL = "1";
const POSGRADO_NIVEL = "2";
const ADMISIONES_NIVEL = "3";
const ejSelect = [{ 'txt': 'Alola', 'id': 1 }, { 'txt': 'Fium', 'id': 3 }, { 'txt': 'Powder', 'id': 2 }]
const nivel = [{ 'txt': 'Grado', 'id': 1 }, { 'txt': 'Postgrado', 'id': 2 }, { 'txt': 'Admisiones', 'id': 3 }]
const tipoCalc = {
    'S': (duracion, periodos) => {
        let semanas = 0;
        if (periodos.find(x => { return /PAE/i.test(x.label) }) !== undefined) {
            semanas += 8;
        }
        var perOrd = periodos.filter(x => { return /PAO/i.test(x.label) });
        semanas += perOrd.length * 20

        return semanas * duracion
    },
    'H': (duracion, periodos) => { return duracion * periodos.length },
    'A': (duracion, periodos) => { return duracion }
    //h semestral a anual s semanal
  }

const valUATHP = 'CA'
const ANIO = '2022'

class FormularioActVice extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            idForm: this.props.idForm ?? '0', fila: this.props.profesor.solicitudForm ?? {}, 
            next: false, profesor: this.props.profesor ?? null, idProf: this.props.idProf ?? '0',
            nombreProf: this.props.nombreProf ?? '',
            idUnidad: this.props.idUnidad ?? 0,
            dataForm: this.props.dataForm ?? [], readOnly: false,
            dataUATH: this.props.dataUATH ?? [],
            infoDelegado: this.props.infoDelegado ?? false,
            horas: this.props.profesor.solicitudForm != null ? this.props.profesor.solicitudForm.horasTotal : this.props.profesor.totalHoras,
            multiTermino: "",
            terminos: this.props.profesor.solicitudForm != null ? this.props.profesor.solicitudForm.termino.trim().split(" ") : [],
            termino: this.props.profesor.strPeriodo,
            /*termino: ' PAE 2021 PAO 2021-1 PAO 2021-2',*/
            mensaje: '', viewDelegar: this.props.viewDelegar, infoDelegar: this.props.profesor.infoDelegado ?? null,
            sisUATH: this.props.profesor.sisUATH ?? 'XX',
            /*sisUATH: this.props.profesor.intIdValidacionDet == 9089 ? 'CA' : this.props.profesor.intIdValidacionDet == 9094 ? 'CV' : this.props.profesor.intIdValidacionDet == 9090 ? 'RE': 'XX',*/
            roles: this.props.roles ?? [],
            banderaDecano: this.props.banderaDecano ?? false,
            alertPrograma: true, alertUnidad: true, alertNivel: true, alertTermino: true,
            FormEstado: [{ cod: 'R', nombre: '' },{ cod: 'N', nombre: '' }, { cod: 'L', nombre: 'Loading....' }, { cod: 'B', nombre: 'Error' }, { cod: 'G', nombre: 'Listo' }],
            formState: 'N',
            nivelBeta: 1,
            file: undefined,
            fileName: undefined,
            fileState: 'N',
            rutaArchivo: '',
            formaFile: {'fileName': undefined, 'formFile': undefined },
            promcarr: this.props.profesor.sisUATH == 'CC' || this.props.profesor.sisUATH == 'CP' || this.props.profesor.sisUATH == 'CV' ? 'C' : this.props.profesor.sisUATH == 'CA' && this.props.profesor.solicitudForm !=null && this.props.profesor.solicitudForm.idcarrera > 0 ? 'C' : 'P',
            /*promcarr: this.props.profesor.intIdValidacionDet == 9089 ? this.props.profesor.solicitudForm.idcarrera > 0 ? 'C' : 'P' : this.props.profesor.intIdValidacionDet == 9094 ? 'C': 'P',*/
            typeSelect: [{ cod: 'P', nombre: 'Programa' }, { cod: 'C', nombre: 'Carrera' }],
            EditHoras: this.props.profesor.tieneLimite ?? 'N'            
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleMultipleChange = this.handleMultipleChange.bind(this);
        this.onChangeFile = this.onChangeFile.bind(this);
        this.onChangePorC = this.onChangePorC.bind(this);        
        //console.log('unidad: ',this.props.idUnidad);
        //console.log('terminos', this.state.terminos);
        //console.log('fila: ', this.state.fila);
        //console.log('infoDelegar: ', this.state.infoDelegar);

    }

    onChangeFile(e) {        
        //console.log(e.target.files[0]);
        //console.log(e.target.files[0].name);
        this.setState({ file: e.target.files[0], fileName: e.target.files[0].name })
    }

    onChangePorC(e) {
        /*console.log(e.target.value);*/
        var id = e.target.value;        
        this.setState({ promcarr: id });
    }

    needProgram(text) {
        let list = ['RE', 'VR', 'DG'];
        return list.includes(text);
    }

    handleUpFile() {        
        this.setState({ fileState: 'L' });
        var dto = this.state.fila;
        //console.log("formFile", this.state.file);
        //console.log("fileName", this.state.fileName);
        let formData = new FormData();
        formData.set("fileName", this.state.fileName);
        formData.append("formFile", this.state.file);
        //735650, 694076
        try {
            fetch(local + "File/CargarDocumento",
                {                    
                    method: 'POST',
                    body: formData
                })
                .then(response => response.json())
                .then(data => {
                    /*console.log(data);*/
                    if (data.operation.length > 0) {                        
                        this.setState({ fileState: 'B' });
                    } else {
                        dto.rutaarchivo = data.idFile;
                        this.setState({ fila: dto, fileState: 'G' });
                    }
                    
                });
            /*console.log(this.state.fila);*/
        } catch (ie) {
            this.setState({ fileState: 'B' });
            console.log("Error: " + ie);
        }      
        /*this.setState({ fileState: 'B' });*/
    }

    getPdf(link) {
        let a = link.split(',');
        let id = a[a.length - 1];
        let enlace = localFront + 'DescargarDocumento/' + id;
        window.open(enlace, '_blank', 'noopener,noreferrer');
    }

    handleInputChange(event) {
        const target = event.target;        
        const name = target.name;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        var dto = this.state.fila;
        let duracionTipo = 0;
        if (dto.nhorasSem > 0) {
            duracionTipo = dto.nhorasSem;            
        } else {
            duracionTipo = this.state.profesor.duracionTipo;
        }
        /*console.log('before',dto);*/
        if (name === "nivel") {
            /*console.log(value)*/
            if (value === GRADO_NIVEL || value === POSGRADO_NIVEL) {
                //console.log('no readonly')
                //console.log(dto.nivel !== value)
                if (dto.nivel !== value) {
                    this.setState({ readOnly: false, terminos: [] });
                } else {
                    this.setState({ readOnly: false });
                }

            } else {
                /*console.log('si readonly')*/
                this.setState({ readOnly: true });
            }

        } else if ((name === "fechaInicio" || name === "fechaFin")) {
            let semanas = 0;
            if (name === "fechaInicio" && dto["fechaFin"] !== undefined) {
                semanas = getWeeksDiff(Date.parse(value), Date.parse(dto["fechaFin"]));
                let horas = semanas * duracionTipo;
                this.setState({ horas: horas });
            } else if (name === "fechaFin" && dto["fechaFin"] !== undefined) {
                semanas = getWeeksDiff(Date.parse(dto["fechaInicio"]), Date.parse(value));
                let horas = semanas * duracionTipo;
                this.setState({ horas: horas });
            }

        } else if (name === 'idprograma') {
            dto['idcarrera'] = 0;
        } else if (name === 'idcarrera') {
            dto['idprograma'] = 0;
        } else if (name === 'nhorasSem') {
            let min = 1;
            let max = this.state.profesor.duracionTipo;
            let semanas = 0;
            value = Math.max(min, Math.min(max, Number(value)));
            if (dto["fechaInicio"] !== undefined && dto["fechaFin"] !== undefined) {
                semanas = getWeeksDiff(Date.parse(dto["fechaInicio"]), Date.parse(dto["fechaFin"]));
                let horas = semanas * value;
                /*console.log('horas', horas, 'semanas', semanas, 'duracionTipo', value);*/
                this.setState({ horas: horas });
            }           
            
        }
        dto[name] = value;

        this.setState({ fila: dto });
        /*console.log('fila', this.state.fila); */       
    }

    handleMultipleChange = (selectedChange) => {
        /*console.log('terminos', this.state.terminos)  */      
        if (selectedChange.length !== 0) {
            /*console.log('existe', selectedChange)*/
            var dto = this.state.fila;
            /*console.log('fila',dto)*/
            let horas = this.state.horas;
            //console.log('terminos', this.state.dataForm.terminos)
            //console.log('horas', horas)            
            const minPeriodo = Math.min(...selectedChange.map(x => x.value))
            const maxPeriodo = Math.max(...selectedChange.map(x => x.value))
            let duracion = this.state.profesor.duracionTipo;
            if (dto.nhorasSem > 0) {
                duracion = dto.nhorasSem;
            }
            const tipoCalculo = this.state.profesor.tipoCalculo
            let values = "";
            selectedChange.forEach(element => {
                values += element.value + " "
            });
            if (this.state.fila.nivel === GRADO_NIVEL) {
                dto["fechaInicio"] = this.state.dataForm.terminos['grado'].find(x => x.idPeriodo === minPeriodo).fechaInicio
                dto["fechaFin"] = this.state.dataForm.terminos['grado'].find(x => x.idPeriodo === maxPeriodo).fechaFin
            } else if (this.state.fila.nivel === POSGRADO_NIVEL) {
                dto["fechaInicio"] = this.state.dataForm.terminos['posgrado'].find(x => x.idPeriodo === minPeriodo).fechaInicio
                dto["fechaFin"] = this.state.dataForm.terminos['posgrado'].find(x => x.idPeriodo === maxPeriodo).fechaFin
            }
            /*console.log('dto new ',dto);*/
            if(tipoCalculo === "S"){
                let semanas = getWeeksDiff(Date.parse(dto["fechaInicio"]), Date.parse(dto["fechaFin"]));
                /*console.log(selectedChange.filter(x => { return /PAO/i.test(x.label) }))*/
                if(selectedChange.filter(x => { return /PAO/i.test(x.label) }).length >= 2 )
                    --semanas;

                horas = semanas * duracion;
            }else{
                horas = tipoCalc[tipoCalculo](duracion, selectedChange);
            }
            //console.log('ACTIVIDAAAAAD HORAS MEN')
            //console.log(horas);

            this.setState({ multiTermino: values, fila: dto, horas: horas, terminos: selectedChange.map(x => x.value.toString()) }, () =>
                //console.log('Seleccionado Multiple: ', this.state.multiTermino)
                console.log('')
            )
        }
        else {
            /*console.log('no existe', selectedChange)*/
            this.setState({ multiTermino: "", horas: this.state.profesor.totalHoras, terminos: [] })
        }
    }

    cleanForm = () => {
        /*console.log('entro a clean y limpio')*/
        let profesor = this.state.fila;
        profesor.fechaInicio = "";
        profesor.fechaFin = ""
        profesor.termino = "0"
        profesor.nivel = "0"
        profesor.idCargaUnidad = "0"
        profesor.idcarrera = "0"
        profesor.idprograma = "0"
        profesor.fechadocumento = ""
        this.setState({
            fila: profesor, readOnly: true
        })
        /*console.log(this.state.fila)*/
    }

    populateAUTH(unidad) {
        fetch(local + 'validacion/getdataUATH/' + unidad, {
            method: 'GET'
        }).then(response => response.json())
            .then(data => {
                /*console.log("DATAUATH", data)*/
                this.setState({ dataUATH: data })
            }).catch(function F(error) {
                console.log(error);
            });
    }

    handleSave = (event) => {
        event.preventDefault();
        let problemas = 0;
        const forma = new FormData(event.target);
        let dto = this.state.fila;
        /*console.log(forma)*/

        if (this.state.profesor["strAccion"] === "Eliminar Carga") {
            dto = toPostRequest(this.state.profesor);
            dto["observacion"] = forma.get("observacion")
            dto["totalHoras"] = 0
        } else {
            forma.forEach((value, clave) => {
                dto[clave] = value;
            })
            if (dto != null) {
                dto["idPersona"] = this.state.idProf;
                dto["idValidacionDet"] = this.state.idForm;
                /* dto["idAutoridad"]= this.state.idautoridad; */
            }
            dto["termino"] = this.state.multiTermino === '' ? this.state.terminos.join(' ') : this.state.multiTermino;
        }

        dto["aprobado"] = 1
        const data = JSON.stringify(dto);
        /*console.log(data);*/        

        
        if(this.state.profesor.strAccion !== "Eliminar Carga"){
            if (this.state.fila.idCargaUnidad === "0" || this.state.fila.idCargaUnidad === undefined) {
                problemas++;
                this.setState({ alertUnidad: false })
            } else {
                this.setState({ alertUnidad: true });
            }

            if (this.state.fila.nivel === "0" || this.state.fila.nivel === undefined) {
                problemas++;
                this.setState({ alertNivel: false })
            } else {
                this.setState({ alertNivel: true });
            }
            //console.log(this.state.terminos.length)
            //console.log(this.state.terminos)
            if (this.state.terminos.length === 0) {
                problemas++;
                this.setState({ alertTermino: false })
            } else {
                this.setState({ alertTermino: true });
            }
        }

        
        if (problemas === 0) {
            this.setState({ formState: 'L' });
             /*to test*/
         //const val = {termino: this.state.multiTermino === '' ? this.state.terminos.join(' ') : this.state.multiTermino, 
         //     horasTotal: this.state.profesor.strAccion === 'Eliminar Carga' ? 0 : parseInt(dto['totalHoras']), strObservacion: dto['observacion'], fechaFin: dto.fechaFin, fechaInicio: dto.fechaInicio,
         // nivel: dto.nivel, idCargaUnidad: dto.idCargaUnidad}
         //this.props.method(dto["idValidacionDet"], 'A', val)
         //        // const objUpdated = {}
         //        MySwal.fire({
         //            icon: 'success',
         //            title: 'Solicitud ingresada',
         //            text: 'Datos guardados exitosamente!',
         //            confirmButtonText: 'Listo',
         //            timer: 5000
         //        })        

        fetch(local + 'Validacion/PostValidacion', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: data,
        }).then((response) => {
            if (response.ok) {
                this.setState({ next: true });
                /*console.log('alola')*/
                dto['termino'] = this.state.multiTermino === '' ? this.state.terminos.join(' ') : this.state.multiTermino;
                const val = {
                    termino: this.state.multiTermino === '' ? this.state.terminos.join(' ') : this.state.multiTermino,
                    horasTotal: parseInt(dto['totalHoras']), strObservacion: dto['observacion'],
                    fechaFin: dto.fechaFin, fechaInicio: dto.fechaInicio,
                    nivel: dto.nivel, idCargaUnidad: dto.idCargaUnidad,
                    ndocumento: dto.ndocumento, fechadocumento: dto.fechadocumento,
                    nhorasSem: dto.nhorasSem, idprograma: dto.idprograma, idcarrera: dto.idcarrera
                }

                this.props.method(dto["idValidacionDet"], 'A', val)
                /*console.log("dto", val);*/
                // const objUpdated = {}
                this.setState({ formState: 'N' });
                MySwal.fire({
                    icon: 'success',
                    title: 'Solicitud ingresada',
                    text: 'Datos guardados exitosamente!',
                    confirmButtonText: 'Listo',
                    timer: 5000
                })
            } else {
                this.setState({ formState: 'N' });
                window.alert('fallo post')
            }})
        } else {
            this.setState({ formState: 'N' });
            /*console.log("HAY PROBLEMAS")*/
        }
    }

    handleDecision = (estado) => {
        const idDet = this.state.infoDelegar.solicitudCoordinador.idValidDet
        const data = JSON.stringify({ idSolicitudDet: idDet, estado: estado })
        fetch(local + 'Delegacion/PostDecision', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: data,
        }).then((response) => {
            if (response.ok) {
                /*console.log('alola')*/
                MySwal.fire({
                    icon: 'success',
                    title: 'Solicitud ingresada',
                    text: 'Datos guardados exitosamente!',
                    confirmButtonText: 'Listo',
                    timer: 5000
                })
            } else {
                response.json().then(data => {
                    /*console.log(data);*/
                    MySwal.fire(
                        'Error',
                        data.lMensajesError[0],
                        'error'
                    )
                })

            }
        });
    }

    render() {

        let multiTermino = [];
        const { infoDelegar, sisUATH, promcarr, EditHoras, termino, infoDelegado } = this.state;
        //console.log(infoDelegado)

        //console.log('UATH: ', sisUATH);
        //console.log('infoDelegar: ', infoDelegar);        
        //console.log('Fila: ', this.state.fila);                      

        const optGrado = this.state.dataForm.terminos['grado'].map(ej =>
            ({ value: ej.idPeriodo, label: ej.nombre })
        );

        const optPosgrado = this.state.dataForm.terminos['posgrado'].map(ej =>
            ({ value: ej.idPeriodo, label: ej.nombre })
        );

        let nivelBeta = this.state.profesor.strTipo === "A|P" ? POSGRADO_NIVEL : GRADO_NIVEL;

        //Dterminar los Terminos seleccionados anteriormente.
        let terminor = termino.replace('PAE 20', 'PAE-20');
        terminor = terminor.replace('PAO 20', 'PAO-20');
        terminor = terminor.replace('PAO 20', 'PAO-20');
        let strTermino = terminor.trim().split(" ");

        const strTerminoFinal = strTermino.map(obj => {
            // 👇️ if id equals 2 replace object
            if (obj.includes('PAE-20')) {
                return obj.replace('PAE-20', 'PAE 20');
            } else if (obj.includes('PAO-20')) {
                return obj.replace('PAO-20', 'PAO 20');
            }

            // 👇️ otherwise return object as is
            return obj;
        });

        let optChosed = this.state.terminos.length > 0 ?
            this.state.fila.nivel === GRADO_NIVEL ?
                optGrado.filter((x) => { return this.state.terminos.includes(x.value.toString()) })
                : optPosgrado.filter((x) => { return this.state.terminos.includes(x.value.toString()) })            
                : [];

        //console.log('Original: ', termino)
        //console.log('Replace: ', terminor)        
        //console.log('strTermino trim: ', strTermino)
        //console.log('Termino Final: ', strTerminoFinal)
        //console.log('optChosed', optChosed)
        //console.log('optChosed', optGrado)

        let idCargaUnidad = this.state.profesor.unidadPlanifica != null ? this.state.dataForm.unidades.filter(x => x.nombreUnidad === this.state.profesor.unidadPlanifica).map(ex => ex.idUnidad) : 0;

        //let idtermino = nivel === 1 ? this.state.dataForm.terminos['grado'].filter(x => x.nombre === termino || x.nombre === terminoCut).map(x => { return x.idPeriodo }) : this.state.dataForm.terminos['posgrado'].filter(x => x.nombre === termino || x.nombre === terminoCut).map(x => { return x.idPeriodo });
        //console.log(idtermino);

        //let fechaInicioBeta = nivel === 1 ? this.state.dataForm.terminos['grado'].find(x => x.nombre === termino || x.nombre === terminoCut).fechaInicio : this.state.dataForm.terminos['posgrado'].find(x => x.nombre === termino || x.nombre === terminoCut).fechaInicio;

        //let fechaFinBeta = nivel === 1 ? this.state.dataForm.terminos['grado'].find(x => x.nombre === termino || x.nombre === terminoCut).fechaFin : this.state.dataForm.terminos['posgrado'].find(x => x.nombre === termino || x.nombre === terminoCut).fechaFin;
        //console.log('fechaInicio', fechaInicioBeta);
        //console.log('fechaFin', fechaFinBeta);

        //console.log(optChosed)
        //console.log('Profesor', this.state.profesor)
        //console.log('Tipo', this.state.nivelBeta)
        //console.log(this.state.dataForm.terminos)
        //console.log('fila: ',this.state.fila.leght)
        //console.log(optGrado.filter((x) => { return this.state.terminos.includes(x.value.toString()) }));
        optGrado.filter((x) => { return this.state.terminos.includes(x.value.toString()) })

        if (this.state.multiTermino != "") {
            multiTermino = this.state.multiTermino.trim().split(" ");
        }        

        return (
            <div>
                <Form id={'form' + this.state.idForm} onSubmit={this.handleSave}>
                    {(this.state.viewDelegar === "2" && infoDelegar.estadoCoordinador === "R") || this.state.profesor.strAccion === "Eliminar Carga" ?
                        <></>
                        : sisUATH != 'XX' ?
                            <Row  >
                                <Col md={2}  >
                                    <FormGroup >
                                        <Label for="typeCalculo" >
                                            Tipo Calculo
                                        </Label>
                                        {this.state.viewDelegar === "2" ?
                                            <Input
                                                id={"typeCalculo" + this.state.idForm}
                                                name="typeCalculo"
                                                type="typeCalculo"
                                                value={this.state.profesor.tipoCalculo === 'S' ? 'Semanal' : this.state.profesor.tipoCalculo === 'A' ? 'Anual' : 'Semestral'}
                                                readOnly
                                                style={{ padding: "0.375rem 0.375rem" }}
                                            />
                                            :
                                            <Input
                                                id={"typeCalculo" + this.state.idForm}
                                                name="typeCalculo"
                                                type="typeCalculo"
                                                value={this.state.profesor.tipoCalculo === 'S' ? 'Semanal' : this.state.profesor.tipoCalculo === 'A' ? 'Anual' : 'Semestral'}
                                                readOnly
                                                style={{ padding: "0.375rem 0.375rem" }}
                                            />
                                        }
                                    </FormGroup>
                                </Col>
                                <Col md={2}  >
                                    <FormGroup >
                                        <Label for="nhorasSem" >
                                            Número Horas 
                                        </Label>
                                        {this.state.viewDelegar === "2" ?
                                            <Input
                                                id={"nhorasSem" + this.state.idForm}
                                                name="nhorasSem"
                                                type="text"
                                                value={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.nhorasSem : ''}
                                                readOnly
                                                style={{ padding: "0.375rem 0.375rem" }}
                                            />
                                            :
                                            <Input
                                                className="mb-3"
                                                name='nhorasSem'
                                                id={'nhorasSem' + this.state.idForm}
                                                type='number'
                                                readOnly={EditHoras == 'N' || this.props.banderaDecano ? true : false}                                                value={this.state.fila != null && this.state.fila.nhorasSem > 0 ? this.state.fila.nhorasSem : this.state.profesor.duracionTipo}
                                                onChange={this.handleInputChange}
                                                
                                            />
                                        }
                                    </FormGroup>
                                </Col>
                                <Col md={2}>
                                    {sisUATH === "CA" ?
                                        <FormGroup >
                                            <Label for="idprograma">
                                                Programa/Carrera
                                            </Label>
                                            <Input
                                                className="mb-3"
                                                name='s'
                                                id={'s' + this.state.idForm}
                                                onChange={this.onChangePorC}
                                                value={promcarr}
                                                hidden={this.state.viewDelegar === "2" ? true : false}
                                                type="select"
                                                readOnly={this.props.banderaDecano}
                                            >
                                                {this.state.typeSelect.map(ej =>
                                                    <option key={'selectP-' + ej.cod} select={promcarr == ej.cod} value={ej.cod}>{ej.nombre}</option>
                                                )}
                                            </Input> </FormGroup > : <></>}
                                </Col>
                                {!this.needProgram(sisUATH) ? promcarr == 'P' ? <Col md={5} >
                                    <FormGroup >
                                        <Label for="idprograma">
                                            Programa
                                        </Label>
                                        {this.state.viewDelegar === "2" ? <Input
                                            className="mb-3"
                                            type='text'
                                            name='idprograma'
                                            id={'idprograma' + this.state.idForm}
                                            readOnly
                                            defaultValue={infoDelegar.solicitudCoordinador != null ? this.state.dataUATH.programas.find(
                                                x => x.idPrograma === parseInt(infoDelegar.solicitudCoordinador.idprograma)).nombrePrograma
                                                : ''}
                                        /> :
                                            <Input
                                                className="mb-3"
                                                name='idprograma'
                                                id={'idprograma' + this.state.idForm}
                                                type="select"
                                                value={this.state.fila.idprograma}
                                                onChange={this.handleInputChange}
                                                readOnly={this.props.banderaDecano}
                                            >
                                                <option key="0" value="0" >Elija la programa</option>
                                                {this.state.dataUATH.programas.map(ej =>
                                                    <option key={ej.idprograma} selected={this.state.fila.idprograma == ej.idprograma} value={ej.idPrograma}>{ej.nombrePrograma}</option>
                                                )}
                                            </Input>}
                                        <Label hidden={this.state.alertPrograma} style={{ color: 'red' }}>
                                            *Por favor seleccione una unidad.
                                        </Label>
                                    </FormGroup>
                                </Col> :
                                    <Col md={5} >
                                        <FormGroup >
                                            <Label for="idcarrera">
                                                Carrera
                                            </Label>
                                            {this.state.viewDelegar === "2" ? <Input
                                                className="mb-3"
                                                type='textarea'
                                                name='idcarrera'
                                                id={'idcarrera' + this.state.idForm}
                                                readOnly
                                                defaultValue={infoDelegar.solicitudCoordinador != null ? this.state.dataUATH.carreras.find(
                                                    x => x.idCarrera === parseInt(infoDelegar.solicitudCoordinador.idcarrera)).nombreCarrera
                                                    : ''}
                                            /> :
                                                <Input
                                                    className="mb-3"
                                                    name='idcarrera'
                                                    id={'idcarrera' + this.state.idForm}
                                                    type="select"
                                                    value={this.state.fila.idcarrera}
                                                    onChange={this.handleInputChange}
                                                >
                                                    <option key="0" value="0" >Elija la carrera</option>
                                                    {this.state.dataUATH.carreras.map(ej =>
                                                        <option key={ej.idCarrera} selected={this.state.fila.idcarrera == ej.idCarrera} value={ej.idCarrera}>{ej.nombreCarrera}</option>
                                                    )}
                                                </Input>}
                                            <Label hidden={this.state.alertPrograma} style={{ color: 'red' }}>
                                                *Por favor seleccione una unidad.
                                            </Label>
                                        </FormGroup>
                                    </Col>
                                    : <></>}
                            </Row>
                            : <Row  >
                                <Col md={2}  >
                                    <FormGroup >
                                        <Label for="nhorasSem" >
                                            Tipo Calculo
                                        </Label>
                                        {this.state.viewDelegar === "2" ?
                                            <Input
                                                id={"typeCalculo" + this.state.idForm}
                                                name="typeCalculo"
                                                type="typeCalculo"
                                                value={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.nhorasSem : ''}
                                                readOnly
                                                style={{ padding: "0.375rem 0.375rem" }}
                                            />
                                            :
                                            <Input
                                                id={"typeCalculo" + this.state.idForm}
                                                name="typeCalculo"
                                                type="typeCalculo"
                                                value={this.state.profesor.tipoCalculo === 'S' ? 'Semanal' : this.state.profesor.tipoCalculo === 'A' ? 'Anual' : 'Semestral'}
                                                readOnly
                                                style={{ padding: "0.375rem 0.375rem" }}
                                            />
                                        }
                                    </FormGroup>
                                </Col>
                                <Col md={2}  >
                                    <FormGroup >
                                        <Label for="nhorasSem" >
                                            Número Horas
                                        </Label>
                                        {this.state.viewDelegar === "2" ?
                                            <Input
                                                id={"nhorasSem" + this.state.idForm}
                                                name="nhorasSem"
                                                type="text"
                                                value={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.nhorasSem : ''}
                                                readOnly
                                                style={{ padding: "0.375rem 0.375rem" }}
                                            />
                                            :
                                            <Input
                                                className="mb-3"
                                                name='nhorasSem'
                                                id={'nhorasSem' + this.state.idForm}
                                                type='number'
                                                value={this.state.fila != null && this.state.fila.nhorasSem > 0 ? this.state.fila.nhorasSem : this.state.profesor.duracionTipo}
                                                onChange={this.handleInputChange}
                                                readOnly={this.props.banderaDecano}
                                            />
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                    }
                    {(this.state.viewDelegar === "2" && infoDelegar.estadoCoordinador === "R") || this.state.profesor.strAccion === "Eliminar Carga" ?
                        <></>
                        :
                        <Row  >
                            <Col md={2}  >
                                <FormGroup >
                                    <Label for="anio" >
                                        Año
                                    </Label>
                                    <Input
                                        id={"anio" + this.state.idForm}
                                        name="anio"
                                        readOnly
                                        defaultValue={this.state.profesor.anio}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={2} >
                                <FormGroup >  
                                    <Label for="totalHoras">
                                        Total horas
                                    </Label>
                                    {this.state.viewDelegar === "2" ?
                                        <Input
                                            id={"horas" + this.state.idForm}
                                            name="totalHoras"
                                            readOnly
                                            defaultValue={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.horasTotal
                                                : ''}
                                        />
                                        :
                                    <Input
                                        id={"horas" + this.state.idForm}
                                        name="totalHoras"
                                        onChange={this.handleInputChange}
                                        readOnly
                                        value={this.state.horas}
                                    />
        }
                                </FormGroup>
                            </Col>
                            <Col md={4} >
                                <FormGroup >
                                    <Label for="profesor">
                                        Profesor
                                    </Label>
                                    <Input
                                        id={"profesor" + this.state.idForm}
                                        name="profesor"
                                        readOnly
                                        defaultValue={this.state.nombreProf.split("/")[1]}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4} >
                                <FormGroup >
                                    <Label for="nivel">
                                        Nivel
                                    </Label>
                                    {this.state.viewDelegar === "2" ?
                                        <Input
                                            id={"nivel" + this.state.idForm}
                                            name="nivel"
                                            readOnly
                                            defaultValue={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.nivel === "1" ? "Grado" : infoDelegar.solicitudCoordinador.nivel === "2" ? "Posgrado" : "Admisiones"
                                                : ''}
                                        />
                                        : <Input
                                            id={"nivel" + this.state.idForm}
                                            name="nivel"
                                            type="select"
                                            onChange={this.handleInputChange}
                                            value={this.state.fila.nivel}
                                            disabled={this.props.banderaDecano}
                                        >
                                            <option key="0" value="0" >Elija el nivel</option>
                                            {nivel.map(niv =>
                                                <option key={niv.id} value={niv.id}>{niv.txt}</option>
                                            )}
                                        </Input>}
                                    <Label hidden={this.state.alertNivel} style={{ color: 'red' }}>
                                        *Por favor seleccione un nivel.
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    {(this.state.viewDelegar === "2" && infoDelegar.estadoCoordinador === "R") || this.state.profesor.strAccion === "Eliminar Carga" ?
                        <></>
                        :
                        <Row  >
                            <Col md={4}  >
                                <FormGroup >
                                    <Label for="idPlanificadoUnidad" >
                                        Planificado por Unidad
                                    </Label>
                                    <Input
                                        className="mb-3"
                                        type='textarea'
                                        name='idPlanificadoUnidad'
                                        id={'idPlanificadoUnidad' + this.state.idForm}
                                        readOnly
                                        defaultValue={this.state.profesor.unidadPlanifica}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4} >
                                <FormGroup >
                                    <Label for="idCargaUnidad">
                                        Con cargo a la unidad
                                    </Label>
                                    {this.state.viewDelegar === "2" ? <Input
                                        className="mb-3"
                                        type='textarea'
                                        name='idCargaUnidad'
                                        id={'idCargaUnidad' + this.state.idForm}
                                        readOnly
                                        defaultValue={infoDelegar.solicitudCoordinador != null ? this.state.dataForm.unidades.find(
                                            x => x.idUnidad === parseInt(infoDelegar.solicitudCoordinador.idCargaUnidad)).nombreUnidad
                                            : ''}
                                    /> :
                                        <Input
                                            className="mb-3"
                                            name='idCargaUnidad'
                                            id={'idCargaUnidad' + this.state.idForm}
                                            type="select"
                                            value={this.state.fila.idCargaUnidad}
                                            onChange={this.handleInputChange}
                                            disabled={this.props.banderaDecano}
                                        >
                                            <option key="0" value="0" >Elija la unidad</option>
                                            {this.state.dataForm.unidades.map(ej =>
                                                <option key={ej.idUnidad} selected={ej.idUnidad == idCargaUnidad} value={ej.idUnidad}>{ej.nombreUnidad}</option>
                                            )}

                                        </Input>}
                                    <Label hidden={this.state.alertUnidad} style={{ color: 'red' }}>
                                        *Por favor seleccione una unidad.
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col md={4} >
                                <FormGroup >
                                    <Label for="termino">
                                        Periodo
                                    </Label>
                                    <br />
                                    {this.state.viewDelegar === "2" ?
                                        <Label>{infoDelegar.solicitudCoordinador ? infoDelegar.solicitudCoordinador.termino.split(' ').map(x => {
                                            return x === '584' ? 'PAE 2022' : x === '585' ? 'PAO 2022-1' : x === '586' ? 'PAO 2022-2' : ''
                                        }) : ''}</Label>
                                        : <Select
                                            closeMenuOnSelect={false}
                                            isMulti
                                            value={optChosed}
                                            onChange={this.handleMultipleChange}
                                            isDisabled={this.state.banderaDecano ? true : this.state.fila.nivel == GRADO_NIVEL || nivelBeta != '' ? false : this.state.fila.nivel != POSGRADO_NIVEL}
                                            name="termino"
                                            options={this.state.fila.nivel == GRADO_NIVEL || this.state.profesor.strTipo === "A|R" ? optGrado : this.state.fila.nivel == POSGRADO_NIVEL || this.state.profesor.strTipo === "A|P"? optPosgrado :<></>}
                                            placeholder="Elija el término académico"
                                            className="basic-multi-select"                                            
                                        />}
                                    <Label hidden={this.state.alertTermino} style={{ color: 'red' }}>
                                        *Por favor seleccione un periodo.
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    {(this.state.viewDelegar === "2" && infoDelegar.estadoCoordinador === "R") || this.state.profesor.strAccion === "Eliminar Carga" ?
                        <></>
                        :
                        <Row  >
                            <Col md={4}  >
                                <FormGroup >
                                    <Label for="actividad" >
                                        Actividad
                                    </Label>
                                    <Input
                                        className="mb-3"
                                        name='actividad'
                                        id={'actividad' + this.state.idForm}
                                        type='textarea'
                                        readOnly
                                        defaultValue={this.state.profesor.strTipoActividad}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4} >
                                <FormGroup >
                                    <Label for="descripcion">
                                        Descripción de la actividad
                                    </Label>
                                    <Input
                                        name='descripcion'
                                        type='textarea'
                                        id={'descripcion' + this.state.idForm}
                                        readOnly
                                        defaultValue={this.state.profesor.strDescripcion}
                                    >
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={2} >
                                <FormGroup >
                                    <Label for="fechaInicio">
                                        Fecha Ingreso
                                    </Label>
                                    {this.state.viewDelegar === "2" ?
                                        <Input
                                            id={"fechaInicio" + this.state.idForm}
                                            name="fechaInicio"
                                            type="date"
                                            value={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.fechaInicio : ''}
                                            style={{ padding: "0.375rem 0.375rem" }}
                                            readOnly
                                        />
                                        :
                                        <Input
                                            id={"fechaInicio" + this.state.idForm}
                                            name="fechaInicio"
                                            type="date"
                                            value={this.state.fila.fechaInicio}
                                            onChange={this.handleInputChange}
                                            style={{ padding: "0.375rem 0.375rem" }}
                                            readOnly={this.props.banderaDecano}
                                            required
                                        />}
                                </FormGroup>
                            </Col>
                            <Col md={2} >
                                <FormGroup >
                                    <Label for="fechaFin">
                                        Fecha Fin
                                    </Label>
                                    {this.state.viewDelegar === "2" ?
                                        <Input
                                            id={"fechaFin" + this.state.idForm}
                                            name="fechaFin"
                                            type="date"
                                            value={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.fechaFin : ''}
                                            style={{ padding: "0.375rem 0.375rem" }}
                                            readOnly
                                        />
                                        :
                                        <Input
                                            id={"fechaFin" + this.state.idForm}
                                            name="fechaFin"
                                            value={this.state.fila.fechaFin}
                                            type="date"
                                            onChange={this.handleInputChange}
                                            style={{ padding: "0.375rem 0.375rem" }}
                                            readOnly={this.props.banderaDecano}
                                            required
                                        />
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                    }                    
                    {(this.state.viewDelegar === "2" && infoDelegar.estadoCoordinador === "R") || this.state.profesor.strAccion === "Eliminar Carga" ?
                        <></>
                        : sisUATH != 'XX' ?
                        <Row  >
                            <Col md={4}  >
                                <FormGroup >
                                    <Label for="ndocumento" >
                                        Nro Documento
                                        </Label>
                                        {this.state.viewDelegar === "2" ?
                                            <Input
                                                id={"ndocumento" + this.state.idForm}
                                                name='ndocumento'
                                                type='text'
                                                value={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.ndocumento : ''}
                                                style={{ padding: "0.375rem 0.375rem" }}
                                                readOnly
                                            />
                                            :
                                            <Input
                                                className="mb-3"
                                                name='ndocumento'
                                                id={'ndocumento' + this.state.idForm}
                                                type='text'
                                                defaultValue={this.state.fila != null ? this.state.fila.ndocumento : ''}
                                                onChange={this.handleInputChange}
                                                readOnly={this.props.banderaDecano}
                                                required
                                            />
                                        }
                                    
                                </FormGroup>
                            </Col>
                            <Col md={4} >
                                <FormGroup >
                                    <Label for="archivo">
                                        Archivo
                                    </Label>
                                    <Input
                                            name='archivo'
                                            type='file'
                                            id={'archivo' + this.state.idForm}
                                            accept=".pdf"
                                            onChange={this.onChangeFile}
                                            disabled={this.state.fileState === 'L' ? 'disabled' : ''}                                            
                                    >
                                        </Input>
                                        {this.state.viewDelegar === "2" ?
                                            <Input
                                                id={"rutaarchivo" + this.state.idForm}
                                                name="rutaarchivo"
                                                type="text"
                                                value={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.rutaarchivo : ''}
                                                style={{ padding: "0.375rem 0.375rem" }}
                                                readOnly
                                                hidden
                                            />
                                            :
                                            <Input hidden={false}
                                                name='rutaarchivo'
                                                type='text'
                                                id={'rutaarchivo' + this.state.idForm}
                                                value={this.state.fila != null ? this.state.fila.rutaarchivo : ''}
                                                onChange={this.handleInputChange}
                                                required
                                                hidden
                                            >
                                            </Input>
                                        }                                        
                                    <Button
                                        className='btn-success btn-round'
                                        disabled={this.state.fileState === 'L' ? 'disabled' : ''}
                                        onClick={() => this.handleUpFile()}>                                        
                                        {this.state.fileState === 'L' ? <Spinner animation="grow" size='sm' /> : this.state.fileState === 'B' ? <BsFileEarmarkX /> : this.state.fileState === 'G' ? <BsFileEarmarkCheck /> : this.state.fileState === 'R' ? <BsFileEarmarkArrowDown /> : <BsFileEarmarkArrowUp />}                                        
                                    </Button>
                                    &nbsp;
                                        <Label>{this.state.fileState === 'L' ? 'Cargando...' : this.state.fileState === 'B' ? 'Error' : this.state.fileState === 'G' ? 'Listo' : ''}</Label>
                                        {this.state.viewDelegar === "2" ?
                                            <Button className="btn-info btn-round" onClick={() => this.getPdf(infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.rutaarchivo : '')} ><HiDocumentDownload /></Button>
                                            :
                                            this.state.fila != null && this.state.fila.rutaarchivo ?
                                                <Button className="btn-info btn-round" onClick={() => this.getPdf(this.state.fila.rutaarchivo)} ><HiDocumentDownload /></Button>
                                                : <></>
                                        }
                                </FormGroup>
                            </Col>                            
                            <Col md={4} >
                                <FormGroup >
                                    <Label for="fechadocumento">
                                        Fecha Documento
                                    </Label>
                                    {this.state.viewDelegar === "2" ?
                                        <Input
                                            id={"fechadocumento" + this.state.idForm}
                                            name="fechadocumento"
                                            type="date"
                                            value={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.fechadocumento : ''}
                                            readOnly
                                            style={{ padding: "0.375rem 0.375rem" }}                                            
                                        />
                                        :
                                        <Input
                                            id={"fechadocumento" + this.state.idForm}
                                            name="fechadocumento"
                                            type="date"
                                            value={this.state.fila.fechadocumento}
                                            onChange={this.handleInputChange}
                                            style={{ padding: "0.375rem 0.375rem" }}
                                            readOnly={this.props.banderaDecano}
                                            required
                                        />}
                                </FormGroup>
                            </Col>                            
                            </Row>
                            : <></>
                    }                   
                    
                    {this.state.viewDelegar === "2" && (infoDelegar.estadoCoordinador === "R" || this.state.profesor.strAccion === "Eliminar Carga") ?
                        <></>
                        :
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label for="observacionProf">
                                        Observación
                                    </Label>
                                    <Input
                                        id={"observacionProf" + this.state.idForm}
                                        name="observacionProf"
                                        type="textarea"
                                        className='form-control'
                                        readOnly
                                        defaultValue={this.state.profesor.strObservacion}                                        
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Label for="observacion">
                                    {this.state.roles.includes("COORDINADOR") ? "Recomendación al Subdecano" : this.state.viewDelegar === "2" ? "Recomendación del coordinador" : "Recomendación al VRA"}
                                </Label>
                                {this.state.viewDelegar === "2" ?
                                    <Input
                                        id={"observacion" + this.state.idForm}
                                        name="observacion"
                                        type="textarea"
                                        className='form-control'
                                        value={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.strObservacion : ''}
                                        readOnly
                                    />
                                    :
                                    <Input
                                        id={"observacion" + this.state.idForm}
                                        name="observacion"
                                        type="textarea"
                                        className='form-control'
                                        onChange={this.handleInputChange}
                                        defaultValue={this.state.fila.strObservacion}
                                        readOnly={this.props.banderaDecano}
                                        maxLength="500"
                                        required
                                    />
                                }
                            </FormGroup>
                        </Col>
                    </Row>                    
                </Form>
            </div>
        );
    }
}

export default FormularioActVice;